"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prefix = exports.Prefixer = void 0;
class Prefixer {
    constructor(prefix, { delimiter = '#' } = {}) {
        this.transformerId = 'prefix';
        this.prefix = prefix;
        this.delimiter = delimiter;
    }
    parse(formatted) {
        return [this.prefix, formatted].join(this.delimiter);
    }
    format(transformed) {
        return transformed.startsWith([this.prefix, ''].join(this.delimiter))
            ? transformed.slice(this.prefix.length + this.delimiter.length)
            : transformed;
    }
    toJSON() {
        return {
            transformerId: this.transformerId,
            prefix: this.prefix,
            delimiter: this.delimiter
        };
    }
}
exports.Prefixer = Prefixer;
const prefix = (prefix, { delimiter = '#' } = {}) => new Prefixer(prefix, { delimiter });
exports.prefix = prefix;
